import { Button, Checkbox, FormControlLabel, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, TextField } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import useStyles from "../../Styles";
import PaginatedTableActions from "../Table/PaginatedTableActions";

const NotificationList = (props) => {

    const classes = useStyles(props);
    const params = useParams();
    const notificationItems = props.notificationItems;
    const [recipients, setRecipients] = useState({});
    const [deletedRecipients, setDeletedRecipients] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [orderBy, setOrderBy] = useState("name");
    const [direction, setDirection] = useState("asc");
    const [firstLoad, setFirstLoad] = useState("true");

    useEffect(() => {
        if (firstLoad) {
            props.retrieveDistributionList(0, pageSize, orderBy, direction);
            setFirstLoad(false);
        }
        if (props.recipients) {
            setRecipients({ ...props.recipients });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props, params]);

    const saveDistributionList = async () => {
        if (deletedRecipients && deletedRecipients.length > 0) {
            props.deleteRecipients(deletedRecipients);
        }
        let savedRecipients = recipients.results.filter(r => r.emailAddress !== "");
        if (savedRecipients && savedRecipients.length > 0) {
            props.saveRecipients(savedRecipients);
        }

    }

    const handleSort = (column) => {
        let sortDirection = column === orderBy && direction === 'asc' ? 'desc' : 'asc'
        setDirection(sortDirection);
        setOrderBy(column);
        props.retrieveDistributionList(0, pageSize, column, sortDirection);
    }

    const handlePageChange = (pageNumber, pageSize) => {
        props.retrieveDistributionList(pageNumber, pageSize, orderBy, direction);
    }

    const calculateRowsPerPage = (rowsPerPage) => {
        if (!rowsPerPage) {
            return 10;
        }
        if (rowsPerPage <= 10) {
            return 10;
        }
        if (rowsPerPage <= 25) {
            return 25;
        }
        if (rowsPerPage <= 50) {
            return 50;
        }
        return rowsPerPage;
    }

    const handleRowsPerPageChange = (e) => {
        setPageSize(e.target.value);
        props.retrieveDistrbutionList(0, e.target.value, orderBy, direction);
    }

    const handleValueChange = (e, index, fieldName) => {
        let recipient = recipients.results[index];
        if (recipient) {
            recipient[fieldName] = e.target.value;
            recipients.results.splice(index, 1, recipient);
            setRecipients({ ...recipients });
        }
    }

    const handleCheckBoxChange = (e, value, index, fieldName) => {
        let recipient = recipients.results[index];
        if (recipient) {
            recipient[fieldName] = !recipient[fieldName];
            recipients.results.splice(index, 1, recipient);
            setRecipients({ ...recipients });
        }
    }

    const renderAddIcon = (totalCount, index) => {
        if (index === totalCount) {
            return (
                <IconButton onClick={addIconClick}>
                    <AddIcon />
                </IconButton>
            )
        }
    }

    const addIconClick = () => {
        let defaultRecipient = { accountId: params.accountId, name: '', emailAddress: '' };
        notificationItems.forEach(ni => defaultRecipient[ni.fieldName] = false);
        recipients.results.push(defaultRecipient);
        setRecipients({ ...recipients });
    }

    const removeIconClick = (index) => {
        deletedRecipients.push(recipients.results[index]);
        recipients.results.splice(index, 1);
        if (recipients.results.length === 0) {
            recipients.results.push({ accountId: params.accountId, emailAddress: '', sendDaGenerationOfferEmail: false, sendDaLoadOfferEmail: false, sendDaGenerationClearingEmail: false, sendDaLoadClearingEmail: false });
        }
        setDeletedRecipients([...deletedRecipients]);
        setRecipients({ ...recipients });
    }

    const renderRecipients = () => {
        const rows = [];
        if (recipients && recipients.results && recipients.results.length > 0) {
            for (let i = 0; i < recipients.results.length; i++) {
                rows.push(<React.Fragment key={i}>
                    <TableRow key={i}>
                        <TableCell>
                            <TextField name="name" id="name" value={recipients.results[i].name}
                                onChange={(e, index, fieldName) => handleValueChange(e, i, "name")} label="Name" fullWidth />
                        </TableCell>
                        <TableCell>
                            <TextField name="emailAddress" id="emailAddress" value={recipients.results[i].emailAddress}
                                onChange={(e, index, fieldName) => handleValueChange(e, i, "emailAddress")} label="Email Address" fullWidth />
                        </TableCell>
                        {
                            notificationItems.map(ni => {
                                return (
                                    <TableCell key={ni.fieldName}>
                                        <FormControlLabel control={<Checkbox checked={recipients.results[i][ni.fieldName]}
                                            onChange={(e, value, index, fieldName) => handleCheckBoxChange(e, value, i, ni.fieldName)} />} />
                                    </TableCell>
                                )
                            })
                        }
                        <TableCell>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                {renderAddIcon(recipients.results.length - 1, i)}
                                <IconButton onClick={() => removeIconClick(i)}>
                                    <RemoveIcon />
                                </IconButton>
                            </div>
                        </TableCell>
                    </TableRow>
                </React.Fragment>
                )
            }
        }
        return rows;
    }

    return (
        <React.Fragment>
            <TableContainer className={classes.tableContainer}>
                <Table className={classes.table} stickyHeader>
                    <TableHead xs={{ width: "max-content" }}>
                        <TableRow>
                            <TableCell width={175}>
                                <TableSortLabel active={orderBy === "name"} direction={orderBy === "name" ? direction : 'asc'}
                                    onClick={() => handleSort("name")}>
                                    Name
                                    {orderBy === "name" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell width={175}>
                                <TableSortLabel active={orderBy === "emailAddress"} direction={orderBy === "emailAddress" ? direction : 'asc'}
                                    onClick={() => handleSort("emailAddress")}>
                                    Email Address
                                    {orderBy === "emailAddress" ? (<span className={classes.visuallyHidden}>{direction === "desc" ? 'sorted descending' : 'sorted ascending'}</span>) : null}
                                </TableSortLabel>
                            </TableCell>
                            {notificationItems.map(ni => {
                                return (
                                    <TableCell key={ni.fieldName}>{ni.tableLabel}</TableCell>
                                )
                            })}
                            <TableCell />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {renderRecipients()}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination count={recipients.totalCount ? recipients.totalCount : 0} onPageChange={handlePageChange}
                                page={recipients.pageNumber ? recipients.pageNumber : 0}
                                rowsPerPage={calculateRowsPerPage(recipients.pageSize)} onRowsPerPageChange={handleRowsPerPageChange}
                                rowsPerPageOptions={[10, 25, 50]} colSpan={notificationItems.length + 3} ActionsComponent={PaginatedTableActions} />
                        </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
            <Grid container spacing={2}>
                <Grid item xs={6} sm={4} />
                <Grid item xs={6} sm={4} align="center">
                    <Button onClick={() => saveDistributionList()} variant="contained">Save</Button>
                </Grid>
                <Grid item xs={6} sm={4} />
            </Grid>
        </React.Fragment>
    )

}

export default NotificationList;